import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/icon-powered-by.svg'


const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["lottrackr-link-container", { noBg: $setup.props.noBg }]),
    href: $setup.props.redirectTo,
    target: "_blank"
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      class: "powered-img",
      src: _imports_0
    }, null, -1)
  ]))], 10, _hoisted_1))
}